import { Record, Map as ImmutableMap, List } from 'immutable';
import AuditEvent, { AuditEventKeys } from 'automation-ui-management/records/AuditHistory/AuditEvent';
import AuditEventActionMetadata from 'automation-ui-management/records/AuditHistory/AuditEventActionMetadata';
import AuditEventHistoryFilters from 'automation-ui-management/records/AuditHistory/AuditEventHistoryFilters';
import { getRevisionRollupsByFlowId } from 'automation-ui-management/api-client/api/RevisionsApi';
const AuditEventHistoryKeys = {
  AUDIT_EVENTS: 'auditEvents',
  REVISIONS: 'revisions',
  PAGE_ID: 'pageId'
};
export default class AuditEventHistoryV2 extends Record({
  [AuditEventHistoryKeys.AUDIT_EVENTS]: [],
  [AuditEventHistoryKeys.REVISIONS]: [],
  [AuditEventHistoryKeys.PAGE_ID]: null
}, 'AuditEventHistoryV2') {
  constructor(props) {
    const propMap = ImmutableMap(props);
    super(propMap);
  }
  getAuditEvents() {
    return this[AuditEventHistoryKeys.AUDIT_EVENTS];
  }
  getFilteredAuditEvents(auditEventHistoryFilters = null) {
    const auditEvents = this.getAuditEvents();
    if (!auditEventHistoryFilters) {
      return auditEvents;
    }
    return auditEvents.filter(auditEvent => !auditEventHistoryFilters.shouldFilterOut(auditEvent));
  }
  getRevisions() {
    return this[AuditEventHistoryKeys.REVISIONS];
  }
  getPageId() {
    return this[AuditEventHistoryKeys.PAGE_ID];
  }
  setPageId(newPageId) {
    return this.set(AuditEventHistoryKeys.PAGE_ID, newPageId);
  }
  async generateAuditEvents(flowId, pageId, limit, auditEventHistoryFilters) {
    const areFiltersApplied = auditEventHistoryFilters instanceof AuditEventHistoryFilters && auditEventHistoryFilters.filtersAreApplied();
    const response = await getRevisionRollupsByFlowId(flowId, pageId, limit, areFiltersApplied ? auditEventHistoryFilters : undefined);
    const newAuditEvents = response.results.map(event => new AuditEvent({
      // Type difference in service types Come back to this
      [AuditEventKeys.ASSOCIATED_BULK_ENROLLMENT]: event.metadata && 'associatedBulkEnrollment' in event.metadata ? event.metadata.associatedBulkEnrollment : null,
      // Type difference in service types Come back to this
      [AuditEventKeys.AUDIT_EVENT_TYPE]: event.primaryAuditEventType,
      [AuditEventKeys.ALL_AUDIT_EVENT_TYPES]: List(event.allAuditEventTypes),
      [AuditEventKeys.USER_ID]: event.userId,
      [AuditEventKeys.TIMESTAMP]: event.timestamp,
      // Type difference in service types Come back to this
      [AuditEventKeys.REVISIONS]: event.revisions,
      [AuditEventKeys.AUDIT_EVENT_ACTION_METADATA]: new AuditEventActionMetadata({
        addedCount: event.metadata && 'addedCount' in event.metadata ? event.metadata.addedCount : 0,
        deletedCount: event.metadata && 'deletedCount' in event.metadata ? event.metadata.deletedCount : 0,
        editedCount: event.metadata && 'editedCount' in event.metadata ? event.metadata.editedCount : 0
      }),
      [AuditEventKeys.ENROLL_EXISTING_DECISION]: event.metadata && 'enrollExistingDecision' in event.metadata ? event.metadata.enrollExistingDecision : 'NOT_APPLICABLE'
    }));
    const nextPageId = response.paging && response.paging.next && response.paging.next.after || null;
    return {
      newAuditEvents,
      nextPageId
    };
  }
  async updateEvents(flowId, pageId = null, limit = 50, auditEventHistoryFilters = new AuditEventHistoryFilters()) {
    const {
      newAuditEvents,
      nextPageId
    } = await this.generateAuditEvents(flowId, pageId, limit, auditEventHistoryFilters);
    const newRevisions = newAuditEvents.flatMap(auditEvent => auditEvent.revisions);
    const updatedAuditEventHistory = this.update(AuditEventHistoryKeys.REVISIONS,
    // @ts-expect-error this seems like a bug but leaving to prevent regressions
    prevRevisions => [...prevRevisions, newRevisions]).update(AuditEventHistoryKeys.AUDIT_EVENTS, prevAuditEvents => [...prevAuditEvents, ...newAuditEvents]).setPageId(nextPageId);
    return updatedAuditEventHistory;
  }
  clearEvents() {
    return this.update(AuditEventHistoryKeys.REVISIONS, () => []).update(AuditEventHistoryKeys.AUDIT_EVENTS, () => []);
  }
}